module.exports = __webpack_public_path__ + "static/media/plan-mas-libre.a4363c4e.svg";